import React, { ReactElement } from 'react';
import StatusCaution from './StatusCaution';
import StatusError from './StatusError';
import StatusSuccess from './StatusSuccess';
import StatusWarning from './StatusWarning';

const getStatusIcon = (status: string) => {
  switch (status) {
    case 'caution':
      return <StatusCaution />;
    case 'error':
      return <StatusError />;
    case 'success':
      return <StatusSuccess />;
    case 'warning':
      return <StatusWarning />;
    default:
      return null;
  }
};

const StatusIcon = (props: any): ReactElement => {
  const { status } = props;

  return <React.Fragment>{getStatusIcon(status)}</React.Fragment>;
};

export default StatusIcon;
